import OutsidePageLayout from "./OutsidePageLayout";
export default OutsidePageLayout;
